import { useTypedSelector } from "@/config/configureAppStore";
import { useAuth } from "@/lib/firebase/firebaseHooks";

/**
 * Resolves the signed-in user's email for display, Calendly prefill, payments, etc.
 * Firebase `User.email` can be missing or an empty string in some auth flows; we fall back to
 * `userSlice.emailId` from the server so the UI and flows (e.g. invite email match) stay correct.
 */
export function useServerEmail(): string {
  const authUser = useAuth();
  const serverEmailId = useTypedSelector((state) => state.user.emailId);
  return authUser?.email || serverEmailId;
}
